import { render } from "./UpdateDailyAbsenceDetails.vue?vue&type=template&id=486c23ed"
import script from "./UpdateDailyAbsenceDetails.vue?vue&type=script&lang=js"
export * from "./UpdateDailyAbsenceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__